import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, reactive } from 'vue'
import request from '@/utils/request'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'TabsOperationLog' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  appId: {
    type: String,
    required: true,
    validator(value: string) {
      return ['cos_fbu', 'cos_ofbu', 'cos_lbu', 'cos_zbu'].includes(value)
    }
  },
  resourceId: {
    type: String,
    required: true
  },
  tableId: {
    type: String,
    required: true
  }
},
  setup(__props, { expose: __expose }) {

const { t } = useI18n()
const props = __props

const baseEnum: { [key: string]: string } = {
  cos_fbu: '/fbu',
  cos_ofbu: '/ofbu',
  cos_lbu: '/lbu',
  cos_zbu: '/zbu'
}

const queryForm = reactive({ resourceId: props.resourceId })
const columns = computed(() => [
  { title: t('common.operator'), dataIndex: 'createByName', width: 150 },
  { title: t('common.operatorDate'), dataIndex: 'createTime', width: 240 },
  { title: t('common.operationType'), dataIndex: 'operateType', width: 150 },
  { title: t('common.operatorActivity'), dataIndex: 'operateDesc', width: 350 }
])
const getList = (queryForm: object, callBack: (res: any) => void) => {
  request.post(`${baseEnum[props.appId]}/api/operate/log/page/list`, queryForm).then((res) => {
    callBack(res)
  })
}
const tableRef = ref()
const fetch = () => {
  tableRef.value?.fetch()
}
__expose({ fetch })

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    ref_key: "tableRef",
    ref: tableRef,
    serial: "",
    columns: columns.value,
    search: queryForm,
    "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((queryForm) = $event)),
    tableId: __props.tableId,
    onFetch: getList
  }, null, 8, ["columns", "search", "tableId"]))
}
}

})